<template>
  <van-popup
    v-model="innerVisible"
    round
    position="bottom"
    :style="{ maxHeight: '88vh' }"
    closeable
    close-icon="cross"
    @closed="$emit('closed')"
  >
    <div class="price-rule-popup">
      <div class="price-rule-popup__banner">
        <div class="price-rule-popup__banner-icon">
          <van-icon name="shield-o" />
        </div>
        <div class="price-rule-popup__banner-text">
          <div class="price-rule-popup__title">价格保护服务说明</div>
          <div class="price-rule-popup__subtitle">活动商品享市场价对比，购物更安心</div>
        </div>
      </div>

      <div class="price-rule-popup__body">
        <!-- 服务说明 -->
        <div class="price-rule-popup__section">
          <div class="section-title">
            <span class="section-title__dot" />
            服务说明
          </div>
          <p class="section-text">
            参与本次活动且标注「价格保护」的商品，页面将展示<strong>活动售价</strong>与<strong>参考价</strong>的对比。您可在商品详情页复制「京东编码」，前往京东 App 搜索该编码，核对品牌、型号、规格等核心信息一致后，以该商品页面显示的<strong>公开标价</strong>作为比价依据。
          </p>
          <div class="section-callout">
            <van-icon name="clock-o" class="section-callout__icon" />
            <span>下单后 <strong>7 日内</strong>（自提交订单之时起 <strong>168 小时</strong>内）可申请价格保护服务。</span>
          </div>
        </div>

        <!-- 不支持情形 -->
        <div class="price-rule-popup__section price-rule-popup__section--warn">
          <div class="section-title">
            <span class="section-title__dot section-title__dot--warn" />
            不支持价格保护的情形
          </div>
          <p class="section-text section-text--lead">包括但不限于以下情形：</p>
          <ul class="rule-list rule-list--warn">
            <li>
              <strong>特殊促销价格</strong>：秒杀、支付优惠、百亿补贴、PLUS 会员价、大促活动价（含双十一、双十二、618 等）、各类优惠券（支付券、白条券等）、换购、以旧换新礼金、政府补贴、平台补贴、学生价等；
            </li>
            <li>
              <strong>商品状态</strong>：已下架、无库存、仅限特定用户群体购买的商品，以及赠品、生鲜短保品、定制类商品等；
            </li>
            <li>
              <strong>特殊订单</strong>：尚未支付的订单、已申请售后或换新的订单。
            </li>
          </ul>
        </div>

        <!-- 价格名词解释 -->
        <div class="price-rule-popup__section">
          <div class="section-title">
            <span class="section-title__dot" />
            价格名词解释
          </div>
          <div class="term-list">
            <div class="term-item">
              <span class="term-item__name">活动售价</span>
              <span class="term-item__desc">指您购买本活动商品时的实际支付金额，若享有其他优惠，以优惠后实付价为准。</span>
            </div>
            <div class="term-item">
              <span class="term-item__name">市场参考价</span>
              <span class="term-item__desc">同期主流电商平台同款商品的参考标价，仅供比对，不构成承诺售价。</span>
            </div>
            <div class="term-item">
              <span class="term-item__name">立省金额</span>
              <span class="term-item__desc">市场参考价与活动售价的差额，为参考信息，不代表自动赔付金额。</span>
            </div>
          </div>
        </div>

        <!-- 如何比对 -->
        <div class="price-rule-popup__section">
          <div class="section-title">
            <span class="section-title__dot" />
            如何比对同款商品
          </div>
          <ol class="rule-steps">
            <li>
              <span class="rule-steps__num">1</span>
              <span class="rule-steps__text">在商品详情页复制「京东编码」；</span>
            </li>
            <li>
              <span class="rule-steps__num">2</span>
              <span class="rule-steps__text">打开京东 App 或京东官网，搜索该编码定位商品；</span>
            </li>
            <li>
              <span class="rule-steps__num">3</span>
              <span class="rule-steps__text">核对品牌、型号、规格、包装等核心信息是否一致；</span>
            </li>
            <li>
              <span class="rule-steps__num">4</span>
              <span class="rule-steps__text">查看京东同款商品的页面<strong>公开标价</strong>，与您的实际支付金额进行比对；</span>
            </li>
            <li>
              <span class="rule-steps__num">5</span>
              <span class="rule-steps__text">如有疑问，保存比价页面截图，联系平台客服咨询。</span>
            </li>
          </ol>
        </div>

        <!-- 同款认定 -->
        <div class="price-rule-popup__section">
          <div class="section-title">
            <span class="section-title__dot" />
            同款认定参考
          </div>
          <p class="section-text">
            参照行业通用做法，同款商品应以「<strong>京东编码</strong>」作为核心识别依据。比对双方商品需为同一京东编码所对应的同一商品链接，品牌、型号、规格、颜色、容量、包装等核心维度保持一致。
          </p>
          <p class="section-text section-text--gap">
            申请价保时，客服将依据您提供的截图信息，在同期通过京东编码定位同款商品的页面公开标价进行核对。如同一编码对应同款商品且查询价格与您截图所示价格一致，即可为您提供价保服务。
          </p>
        </div>

        <!-- 温馨提示 -->
        <div class="price-rule-popup__section price-rule-popup__section--muted">
          <div class="section-title">
            <span class="section-title__dot section-title__dot--muted" />
            温馨提示
          </div>
          <ul class="rule-list rule-list--muted">
            <li>页面所示「市场参考价」「立省金额」仅供参考；</li>
            <li>比价服务仅适用于当前活动专区内商品；</li>
            <li>已享受其他优惠的订单，以实付金额为计算依据；</li>
            <li>未在本说明中约定的情形，以平台规则为准；</li>
            <li>具体服务流程及审核标准以平台公示及客服答复为准。</li>
          </ul>
        </div>
      </div>

      <van-button
        block
        round
        color="#D23B2E"
        class="price-rule-popup__btn"
        @click="innerVisible = false"
      >
        我知道了
      </van-button>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'PriceCompareRuleDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/priceCompareTheme.scss';

.price-rule-popup {
  padding: 0 16px calc(16px + env(safe-area-inset-bottom));
}

.price-rule-popup__banner {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 16px 0 14px;
  padding: 14px 16px 14px 14px;
  border-radius: 12px;
  background: linear-gradient(135deg, $price-tint-bg 0%, #fff 100%);
  border: 1px solid $price-tint-border;
  padding-right: 36px;
}

.price-rule-popup__banner-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(135deg, $price-primary 0%, #ff6b5a 100%);
  color: #fff;
  font-size: 22px;
}

.price-rule-popup__title {
  font-size: 17px;
  font-weight: 700;
  color: #333;
  line-height: 1.35;
}

.price-rule-popup__subtitle {
  margin-top: 4px;
  font-size: 12px;
  color: #888;
  line-height: 1.45;
}

.price-rule-popup__body {
  max-height: 58vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 4px;
}

.price-rule-popup__section {
  margin-bottom: 10px;
  padding: 12px 14px;
  border-radius: 10px;
  background: $price-tint-bg;
  border: 1px solid $price-tint-border;

  &--warn {
    background: #fffbf5;
    border-color: rgba(255, 125, 0, 0.22);
  }

  &--muted {
    background: #fafafa;
    border-color: #eee;
  }
}

.section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #333;

  &__dot {
    width: 3px;
    height: 14px;
    border-radius: 2px;
    background: $price-primary;
    flex-shrink: 0;

    &--warn {
      background: $price-save;
    }

    &--muted {
      background: #bbb;
    }
  }
}

.section-text {
  margin: 0;
  font-size: 13px;
  line-height: 1.72;
  color: #555;

  strong {
    color: $price-primary;
    font-weight: 600;
  }

  &--lead {
    margin-bottom: 6px;
    font-size: 12px;
    color: #888;
  }

  &--gap {
    margin-top: 8px;
  }
}

.section-callout {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  background: rgba($price-primary, 0.06);
  border: 1px dashed rgba($price-primary, 0.2);
  font-size: 12px;
  line-height: 1.65;
  color: #666;

  &__icon {
    flex-shrink: 0;
    margin-top: 2px;
    font-size: 14px;
    color: $price-primary;
  }

  strong {
    color: $price-primary;
    font-weight: 600;
  }
}

.term-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.term-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.7);

  &__name {
    font-size: 13px;
    font-weight: 600;
    color: #333;
  }

  &__desc {
    font-size: 12px;
    line-height: 1.65;
    color: #666;
  }
}

.rule-list {
  margin: 0;
  padding-left: 16px;
  font-size: 13px;
  line-height: 1.7;
  color: #555;

  li + li {
    margin-top: 6px;
  }

  strong {
    color: #333;
    font-weight: 600;
  }

  &--warn {
    padding-left: 14px;
    font-size: 12px;
    line-height: 1.68;
    color: #666;
  }

  &--muted {
    color: #888;
    font-size: 12px;
    line-height: 1.65;
  }
}

.rule-steps {
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    display: flex;
    align-items: flex-start;
    gap: 8px;

    & + li {
      margin-top: 10px;
    }
  }

  &__num {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    margin-top: 1px;
    border-radius: 50%;
    background: $price-primary;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
  }

  &__text {
    flex: 1;
    min-width: 0;
    font-size: 13px;
    line-height: 1.68;
    color: #555;

    strong {
      color: $price-primary;
      font-weight: 600;
    }
  }
}

.price-rule-popup__btn {
  margin-top: 12px;
  height: 44px;
  font-size: 15px;
  font-weight: 600;
}
</style>
